export enum SettingsSubMenuUrl {
	PERSONAL = '/settings/personal',
	COOKIES = '/settings/cookies',
}
